import React from 'react';

import CommonPage from '../components/common-page/CommonPage';
import MediaStudio from './MediaStudio';
import { FULL_MEDIA_STUDIO_CONFIG } from './config';

import scss from './MediaStudioPage.module.scss';

function MediaStudioPage() {
  return (
    <CommonPage className={scss.page}>
      <MediaStudio config={FULL_MEDIA_STUDIO_CONFIG} />
    </CommonPage>
  );
}

export default MediaStudioPage;
